<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <window title="Basic" height="100%">
          <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </window>
      </div>
      <div class="column is-half">
        <window title="Selectable" height="100%">
          <el-tree :props="props" :load="loadNode" lazy show-checkbox
            @check-change="handleCheckChange"
          >
          </el-tree>
        </window>
      </div>
      <div class="column is-half">
        <window title="Custom leaf node in lazy mode" height="100%">
          <el-tree :props="props1" :load="loadNode1" lazy show-checkbox>
          </el-tree>
        </window>
      </div>
      <div class="column is-half">
        <window title="Disabled checkbox" height="100%">
          <el-tree :data="data3" :props="defaultProps2" show-checkbox
            @check-change="handleCheckChange"
          >
          </el-tree>
        </window>
      </div>
      <div class="column is-half">
        <window title="Default expanded and default checked" height="100%">
          <el-tree :data="data2" show-checkbox node-key="id" :default-expanded-keys="[2, 3]"
            :default-checked-keys="[5]" :props="defaultProps"
          >
          </el-tree>
        </window>
      </div>
      <div class="column is-half">
        <window title="Default expanded and default checked" height="100%">
          <el-tree :data="data5" show-checkbox default-expand-all node-key="id" ref="tree"
            highlight-current :props="defaultProps"
          >
          </el-tree>
          <div class="buttons" style="margin-top:20px">
            <button class="button" @click="getCheckedNodes">get by node</button>
            <button class="button" @click="getCheckedKeys">get by key</button>
            <button class="button" @click="setCheckedNodes">set by node</button>
            <button class="button" @click="setCheckedKeys">set by key</button>
            <button class="button" @click="resetChecked">reset</button>
          </div>
        </window>
      </div>
      <div class="column is-half">
        <window title="Custom node content" height="100%">
          <el-tree :data="data5" show-checkbox node-key="id" default-expand-all
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button type="text" size="mini" @click="() => append(data)">
                  Append
                </el-button>
                <el-button type="text" size="mini" @click="() => remove(node, data)">
                  Delete
                </el-button>
              </span>
            </span>
          </el-tree>
        </window>
      </div>
      <div class="column is-half">
        <window title="Tree node filtering" height="100%">
          <el-input placeholder="Filter keyword" v-model="filterText">
          </el-input>
          <el-tree class="filter-tree" :data="data2" :props="defaultProps" default-expand-all
            :filter-node-method="filterNode" ref="tree2"
          >
          </el-tree>
        </window>
      </div>
      <div class="column is-half">
        <window title="Accordion" height="100%">
          <el-tree :data="data" :props="defaultProps" accordion @node-click="handleNodeClick">
          </el-tree>
        </window>
      </div>
      <div class="column is-half">
        <window title="Draggable" height="100%">
          <el-tree :data="data7" node-key="id" default-expand-all @node-drag-start="handleDragStart"
            @node-drag-enter="handleDragEnter" @node-drag-leave="handleDragLeave"
            @node-drag-over="handleDragOver" @node-drag-end="handleDragEnd" @node-drop="handleDrop"
            draggable :allow-drop="allowDrop" :allow-drag="allowDrag"
          >
          </el-tree>
        </window>
      </div>
    </div>
  </div>
</template>

<script>
let id = 1000;
export default {
  data() {
    const data = [{
      id: 1,
      label: 'Level one 1',
      children: [{
        id: 4,
        label: 'Level two 1-1',
        children: [{
          id: 9,
          label: 'Level three 1-1-1',
        }, {
          id: 10,
          label: 'Level three 1-1-2',
        }],
      }],
    }, {
      id: 2,
      label: 'Level one 2',
      children: [{
        id: 5,
        label: 'Level two 2-1',
      }, {
        id: 6,
        label: 'Level two 2-2',
      }],
    }, {
      id: 3,
      label: 'Level one 3',
      children: [{
        id: 7,
        label: 'Level two 3-1',
      }, {
        id: 8,
        label: 'Level two 3-2',
      }],
    }];
    return {
      data: [{
        label: 'Level one 1',
        children: [{
          label: 'Level two 1-1',
          children: [{
            label: 'Level three 1-1-1',
          }],
        }],
      }, {
        label: 'Level one 2',
        children: [{
          label: 'Level two 2-1',
          children: [{
            label: 'Level three 2-1-1',
          }],
        }, {
          label: 'Level two 2-2',
          children: [{
            label: 'Level three 2-2-1',
          }],
        }],
      }, {
        label: 'Level one 3',
        children: [{
          label: 'Level two 3-1',
          children: [{
            label: 'Level three 3-1-1',
          }],
        }, {
          label: 'Level two 3-2',
          children: [{
            label: 'Level three 3-2-1',
          }],
        }],
      }],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      props: {
        label: 'name',
        children: 'zones',
      },
      count: 1,
      props1: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf',
      },
      data3: [{
        id: 1,
        label: 'Level one 1',
        children: [{
          id: 3,
          label: 'Level two 2-1',
          children: [{
            id: 4,
            label: 'Level three 3-1-1',
          }, {
            id: 5,
            label: 'Level three 3-1-2',
            disabled: true,
          }],
        }, {
          id: 2,
          label: 'Level two 2-2',
          disabled: true,
          children: [{
            id: 6,
            label: 'Level three 3-2-1',
          }, {
            id: 7,
            label: 'Level three 3-2-2',
            disabled: true,
          }],
        }],
      }],
      defaultProps2: {
        children: 'children',
        label: 'label',
        disabled: 'disabled',
      },
      data2: [{
        id: 1,
        label: 'Level one 1',
        children: [{
          id: 4,
          label: 'Level two 1-1',
          children: [{
            id: 9,
            label: 'Level three 1-1-1',
          }, {
            id: 10,
            label: 'Level three 1-1-2',
          }],
        }],
      }, {
        id: 2,
        label: 'Level one 2',
        children: [{
          id: 5,
          label: 'Level two 2-1',
        }, {
          id: 6,
          label: 'Level two 2-2',
        }],
      }, {
        id: 3,
        label: 'Level one 3',
        children: [{
          id: 7,
          label: 'Level two 3-1',
        }, {
          id: 8,
          label: 'Level two 3-2',
        }],
      }],
      data5: [{
        id: 1,
        label: 'Level one 1',
        children: [{
          id: 4,
          label: 'Level two 1-1',
          children: [{
            id: 9,
            label: 'Level three 1-1-1',
          }, {
            id: 10,
            label: 'Level three 1-1-2',
          }],
        }],
      }, {
        id: 2,
        label: 'Level one 2',
        children: [{
          id: 5,
          label: 'Level two 2-1',
        }, {
          id: 6,
          label: 'Level two 2-2',
        }],
      }, {
        id: 3,
        label: 'Level one 3',
        children: [{
          id: 7,
          label: 'Level two 3-1',
        }, {
          id: 8,
          label: 'Level two 3-2',
        }],
      }],
      data4: JSON.parse(JSON.stringify(data)),
      data6: JSON.parse(JSON.stringify(data)),
      filterText: '',
      data7: [{
        label: 'Level one 1',
        children: [{
          label: 'Level two 1-1',
          children: [{
            label: 'Level three 1-1-1',
          }],
        }],
      }, {
        label: 'Level one 2',
        children: [{
          label: 'Level two 2-1',
          children: [{
            label: 'Level three 2-1-1',
          }],
        }, {
          label: 'Level two 2-2',
          children: [{
            label: 'Level three 2-2-1',
          }],
        }],
      }, {
        label: 'Level one 3',
        children: [{
          label: 'Level two 3-1',
          children: [{
            label: 'Level three 3-1-1',
          }],
        }, {
          label: 'Level two 3-2',
          children: [{
            label: 'Level three 3-2-1',
          }],
        }],
      }],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleCheckChange() {
      // console.log(data, checked, indeterminate);
    },
    loadNode1(node, resolve) {
      if (node.level === 0) {
        return resolve([{ name: 'region' }]);
      }
      if (node.level > 1) return resolve([]);

      setTimeout(() => {
        const data = [{
          name: 'leaf',
          leaf: true,
        }, {
          name: 'zone',
        }];

        resolve(data);
      }, 500);

      return true;
    },
    append(data) {
      const newChild = { id: id += 1, label: 'testtest', children: [] };
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(newChild);
    },

    remove(node, data) {
      const { parent } = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
    },

    renderContent(h, { node, data }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span>
            <el-button size="mini" type="text" on-click={ () => this.append(data) }>Append</el-button>
            <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>Delete</el-button>
          </span>
        </span>);
    },
    handleNodeClick() {
      // console.log(data);
    },
    getCheckedNodes() {
      // console.log(this.$refs.tree.getCheckedNodes());
    },
    getCheckedKeys() {
      // console.log(this.$refs.tree.getCheckedKeys());
    },
    setCheckedNodes() {
      this.$refs.tree.setCheckedNodes([{
        id: 5,
        label: 'Level two 2-1',
      }, {
        id: 9,
        label: 'Level three 1-1-1',
      }]);
    },
    setCheckedKeys() {
      this.$refs.tree.setCheckedKeys([3]);
    },
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([{ name: 'Root1' }, { name: 'Root2' }]);
      }
      if (node.level > 3) return resolve([]);

      let hasChild;
      if (node.data.name === 'region1') {
        hasChild = true;
      } else if (node.data.name === 'region2') {
        hasChild = false;
      } else {
        hasChild = Math.random() > 0.5;
      }

      setTimeout(() => {
        let data;
        if (hasChild) {
          data = [{
            name: `zone${this.count + 1}`,
          }, {
            name: `zone${this.count + 2}`,
          }];
          this.count += 2;
        } else {
          data = [];
        }

        resolve(data);
      }, 500);
      return true;
    },
    handleDragStart() {
      // console.log('drag start', node);
    },
    // handleDragEnter(draggingNode, dropNode, ev) {
    handleDragEnter() {
      // console.log('tree drag enter: ', dropNode.label);
    },
    // handleDragLeave(draggingNode, dropNode, ev) {
    handleDragLeave() {
      // console.log('tree drag leave: ', dropNode.label);
    },
    // handleDragOver(draggingNode, dropNode, ev) {
    handleDragOver() {
      // console.log('tree drag over: ', dropNode.label);
    },
    // handleDragEnd(draggingNode, dropNode, dropType, ev) {
    handleDragEnd() {
      // console.log('tree drag end: ', dropNode && dropNode.label, dropType);
    },
    // handleDrop(draggingNode, dropNode, dropType, ev) {
    handleDrop() {
      // console.log('tree drop: ', dropNode.label, dropType);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.label === 'Level two 3-1') {
        return type !== 'inner';
      }
      return true;
    },
    allowDrag(draggingNode) {
      return draggingNode.data.label.indexOf('Level three 3-1-1') === -1;
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
